import { chartColors } from '../enums/chart-colors.enum';
import { MediaTypeEnum } from '../../Basic/enums/media-type.enum';

export const stackedBarColorsConfig = {
    /** Sentiments */
    'POSITIVE': chartColors.agprPositive,
    'NEUTRAL': chartColors.agprNeutral,
    'NEGATIVE': chartColors.agprNegative,
    'NOT_AVAILABLE': chartColors.agprNotAvailable,

    /** Media Types */
    [MediaTypeEnum.ONLINE_NEWS]   : chartColors.agprOnline,
    [MediaTypeEnum.PRINT]         : chartColors.agprPrint,
    [MediaTypeEnum.BLOGS]         : chartColors.agprBlog,
    [MediaTypeEnum.PRESS_RELEASE] : chartColors.agprPressRelease,
    [MediaTypeEnum.TV]            : chartColors.agprTelevision,
    [MediaTypeEnum.RADIO]         : chartColors.agprRadio,
    [MediaTypeEnum.FACEBOOK]      : chartColors.agprFacebook,
    [MediaTypeEnum.TWITTER]       : chartColors.agprX,
    [MediaTypeEnum.INSTAGRAM]     : chartColors.agprInstagram,
    [MediaTypeEnum.REDDIT]        : chartColors.agprReddit,
    [MediaTypeEnum.YOUTUBE]       : chartColors.agprYoutube,
    [MediaTypeEnum.PODCAST]       : chartColors.agprPodcast,
    [MediaTypeEnum.TIKTOK]        : chartColors.agprTiktok,
    [MediaTypeEnum.SNAPCHAT]      : chartColors.agprSnapchat,
    [MediaTypeEnum.THREADS]       : chartColors.agprThreads,
    [MediaTypeEnum.LINKEDIN]      : chartColors.agprLinkedIn,
    [MediaTypeEnum.BLUESKY]       : chartColors.agprBluesky,
    [MediaTypeEnum.WECHAT]        : chartColors.agprWechat,
    [MediaTypeEnum.SINA_WEIBO]    : chartColors.agprSinaWeibo,
    [MediaTypeEnum.TWITCH]        : chartColors.agprTwitch,
    [MediaTypeEnum.PINTEREST]     : chartColors.agprPinterest,
    [MediaTypeEnum.TUMBLR]        : chartColors.agprTumblr,
    [MediaTypeEnum.TELEGRAM]      : chartColors.agprTelegram,
    [MediaTypeEnum.WHATSAPP]      : chartColors.agprWhatsapp,
    [MediaTypeEnum.VK]            : chartColors.agprVK,
    [MediaTypeEnum.OTHER]         : chartColors.agprOther,
    [MediaTypeEnum.MAGAZINE]      : chartColors.agprMagazine,

    /** GA metrics */
    'SESSIONS': chartColors.agprBlue,
    'SESSIONS_NEW': chartColors.agprBlue,
    'SESSIONS_RETURNING': chartColors.agprOrange,
    'USERS': chartColors.agprBlue,
    'USERS_NEW': chartColors.agprBlue,
    'USERS_RETURNING': chartColors.agprOrange
};
